enum HomeType {
    single_family = 'Single Family Home',
    condo = 'Condo',
    townhome = 'Townhome',
}

export default HomeType;
